<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Review Detail</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Review</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="col-md-12">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="message"
                >
                  <strong>Success!</strong> {{ message }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12" v-if="viewstate == 0">
                <h5 class="page-title">
                  Fill your objective goals. This is an opportunity for you to
                  reflect on your achievements, challenges, and overall
                  contributions over the review period
                </h5>
                <div class="accordion" id="accordionExample">
                  <div
                    class="card mb-3"
                    v-for="(rd, index) in review.designationKPIRatings.filter(
                      v => v.designationKPI.type == 1
                    )"
                    :key="`kpi-type1-${index}`"
                  >
                    <div class="card-header" :id="`heading-type1-${index}`">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        :data-target="`#collapse-type1-${index}`"
                        aria-expanded="true"
                        :aria-controls="`collapse-type1-${index}`"
                      >
                        <button class="btn collapsed">
                          {{ rd.designationKPI.title }}
                        </button>
                        <span class="collapsed menu-arrow">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      :id="`collapse-type1-${index}`"
                      class="collapse show"
                      :aria-labelledby="`heading-type1-${index}`"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="d-flex justify-content-between mt-1">
                          <div>{{ rd.designationKPI.description }}</div>
                        </div>
                        <hr class="mt-1" />
                        <div class="row">
                          <div class="col-md-12 text-center">
                            <star-rating
                              v-model="rd.employeeRating"
                              :star-size="30"
                              :max-rating="10"
                              :show-rating="true"
                              :active-on-click="true"
                              :increment="0.5"
                              :clearable="true"
                              :read-only="!(review.status === 0 || review.status === 1)"
                            />
                          </div>
                          <div class="col-md-12">
                            <div class="form-group">
                              <label
                                >Self Appraisal Comment
                                <span class="text-danger">*</span></label
                              >
                              <textarea
                                type="text"
                                rows="5"
                                cols="7"
                                class="form-control"
                                v-model="rd.employeeComment"
                                :disabled="!(review.status === 0 || review.status === 1)"
                              >
                              </textarea>
                            </div>
                          </div>
                            <div class="col-md-12" v-if="review.status === 3">
                               <div class="form-group">
                              <label
                                >Manager Appraisal Rating
                                <span class="text-danger">*</span></label
                              >
                              <div class="text-center">
                                <star-rating
                                  v-model="rd.managerRating"
                                  :star-size="30"
                                  :max-rating="10"
                                  :show-rating="true"
                                  :active-on-click="true"
                                  :increment="0.5"
                                  :clearable="true"
                                  :read-only="true"
                                />
                              </div>
                            </div>
                            </div>
                           <div class="col-md-12" v-if="review.status === 3">
                             <div class="form-group">
                              <label
                                >Manager Appraisal Comment
                                <span class="text-danger">*</span></label
                              >
                              <textarea
                                type="text"
                                rows="5"
                                cols="7"
                                class="form-control"
                                v-model="rd.managerComment"
                                disabled
                              >
                              </textarea>
                            </div>
                           </div>
                           
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" v-if="viewstate == 1">
                <h5 class="page-title">Fill your competencies.</h5>
                <div class="accordion" id="accordionExample">
                  <div
                    class="card mb-3"
                    v-for="(rd, index) in review.designationKPIRatings.filter(
                      v => v.designationKPI.type == 0
                    )"
                    :key="`kpi-type0-${index}`"
                  >
                    <div class="card-header" :id="`heading-type0-${index}`">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        :data-target="`#collapse-type0-${index}`"
                        aria-expanded="true"
                        :aria-controls="`collapse-type0-${index}`"
                      >
                        <button class="btn collapsed">
                          {{ rd.designationKPI.title }}
                        </button>
                        <span class="collapsed menu-arrow">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      :id="`collapse-type0-${index}`"
                      class="collapse show"
                      :aria-labelledby="`heading-type0-${index}`"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="d-flex justify-content-between mt-1">
                          <div>{{ rd.designationKPI.description }}</div>
                        </div>
                        <hr class="mt-1" />
                        <div class="form-group">
                          <div class="text-center">
                            <star-rating
                              v-model="rd.employeeRating"
                              :star-size="30"
                              :max-rating="10"
                              :show-rating="true"
                              :active-on-click="true"
                              :increment="1"
                              :clearable="true"
                              :read-only="!(review.status === 0 || review.status === 1)"
                            />
                          </div>
                          
                        </div>
                        <hr class="mt-1" />
                        <div v-if="review.status === 3">
                          <div class="form-group">
                              <label
                                >Manager Appraisal Rating
                              </label
                              >
                              <div class="text-center">
                                <star-rating
                                  v-model="rd.managerRating"
                                  :star-size="30"
                                  :max-rating="10"
                                  :show-rating="true"
                                  :active-on-click="true"
                                  :increment="1"
                                  :clearable="true"
                                  :read-only="true"
                                />
                              </div>
                            </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" v-if="viewstate == 2">
                <h5 class="page-title">
                  Fill top behaviours. This is an opportunity for you to reflect
                  on your achievements, challenges, and overall contributions
                  over the review period
                </h5>
                <div class="accordion" id="accordionExample">
                  <div
                    class="card mb-3"
                    v-for="(rd, index) in review.designationKPIRatings.filter(
                      v => v.designationKPI.type == 2
                    )"
                    :key="`kpi-type2-${index}`"
                  >
                    <div class="card-header" :id="`heading-type2-${index}`">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        :data-target="`#collapse-type2-${index}`"
                        aria-expanded="true"
                        :aria-controls="`collapse-type2-${index}`"
                      >
                        <button class="btn collapsed">
                          {{ rd.designationKPI.title }}
                        </button>
                        <span class="collapsed menu-arrow">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      :id="`collapse-type2-${index}`"
                      class="collapse show"
                      :aria-labelledby="`heading-type2-${index}`"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="d-flex justify-content-between mt-1">
                          <div>{{ rd.designationKPI.description }}</div>
                        </div>
                        <hr class="mt-1" />
                        <div class="row">
                          <div class="col-md-12 text-center">
                            <star-rating
                              v-model="rd.employeeRating"
                              :star-size="30"
                              :max-rating="10"
                              :show-rating="true"
                              :active-on-click="true"
                              :increment="1"
                              :clearable="true"
                              :read-only="!(review.status === 0 || review.status === 1)"
                            />
                          </div>
                          <div class="col-md-12">
                            <div class="form-group">
                              <label
                                >Self Appraisal Comment
                                <span class="text-danger">*</span></label
                              >
                              <textarea
                                type="text"
                                rows="5"
                                cols="7"
                                class="form-control"
                                v-model="rd.employeeComment"
                                :disabled="!(review.status === 0 || review.status === 1)"
                              >
                              </textarea>
                            </div>
                          </div>
                          <div class="col-md-12 text-center">
                            <star-rating
                              v-model="rd.managerRating"
                              :star-size="30"
                              :max-rating="10"
                              :show-rating="true"
                              :active-on-click="true"
                              :increment="1"
                              :clearable="true"
                              :read-only="true"
                            />
                          </div>
                          <div class="col-md-12">
                            <div class="form-group">
                              <label
                                >Manager Appraisal Comment
                              </label
                              >
                              <textarea
                                type="text"
                                rows="5"
                                cols="7"
                                class="form-control"
                                v-model="rd.managerComment"
                                disabled
                              >
                              </textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" v-if="viewstate == 3">
                <h5 class="page-title">
                  Fill your self assessment and feedback
                </h5>
                <div class="accordion" id="accordionExample">
                  <div
                    class="card mb-3"
                    v-for="(rd, index) in review.employeeReviewSelfAnswers"
                    :key="`self-answer-${index}`"
                  >
                    <div class="card-header" :id="`heading-selfanswer-${index}`">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        :data-target="`#collapse-selfanswer-${index}`"
                        aria-expanded="true"
                        :aria-controls="`collapse-selfanswer-${index}`"
                      >
                        <button class="btn collapsed">
                          {{ rd.reviewSelfQuestion.topic }}
                        </button>
                        <span class="collapsed menu-arrow">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      :id="`collapse-selfanswer-${index}`"
                      class="collapse show"
                      :aria-labelledby="`heading-selfanswer-${index}`"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label
                                >Your Feedback
                                <span class="text-danger">*</span></label
                              >
                              <textarea
                                type="text"
                                rows="5"
                                cols="7"
                                class="form-control"
                                v-model="rd.answer"
                                :disabled="!(review.status === 0 || review.status === 1)"
                              >
                              </textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
          <div class="col-auto float-right ml-auto" style="align-items: center;
    display: flex;
    flex-direction: column;
    gap: 2px;">
                <div style="display: flex; gap: 2px;"><button
                  v-if="viewstate > 0"
                  @click="setPrev"
                  class="btn add-btn"
                >
                  <i class="fa fa-left-arrow m-r-5"></i> Prev
                </button>
                  
                <button
                  v-if="viewstate < 3"
                  @click="setNext"
                  class="btn add-btn"
                >
                  <i class="fa fa-right-arrow m-r-5"></i> Next
                </button>
                <button
                  v-if="viewstate == 3 && (review.status === 0 || review.status === 1)"
                  @click="onEmployeeSubmit(2)"
                  class="btn add-btn"
                  :disabled="!(review.status === 0 || review.status === 1)"
                >
                  <i class="fa fa-right-arrow m-r-5"></i> Submit
                </button>
                </div>
                <div style="display: flex; gap: 2px;">
                  <button
                    v-if="viewstate == 3 && review.status === 3"
                    @click="onEmployeeAccept"
                    class="btn add-btn"
                    :disabled="!(review.status === 3)"
                  >
                    <i class="fa fa-right-arrow m-r-5"></i> Accept Ratings
                  </button>
                  <button
                    v-if="viewstate == 3 && review.status === 3"
                    @click="openDeclineModal"
                    class="btn add-btn"
                    :disabled="!(review.status === 3)"
                  >
                    <i class="fa fa-right-arrow m-r-5"></i> Decline Ratings
                  </button>
                </div>
                
              </div>
          </div>
          <!-- /Page Content -->
        </div>
      </div>
      <!-- /Page Wrapper -->

      <!-- Decline Rating Reason Modal -->
      <div v-if="showDeclineModal" class="modal custom-modal show" style="display: block; background: rgba(0,0,0,0.5);" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Decline Ratings</h5>
              <button type="button" class="close" @click="showDeclineModal = false" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitDecline">
                <div class="form-group">
                  <label>Decline Reason <span class="text-danger">*</span></label>
                  <textarea
                    v-model="declineReason"
                    class="form-control"
                    rows="4"
                    placeholder="Enter reason for declining the ratings"
                    required
                  ></textarea>
                </div>
                <div class="submit-section">
                  <button type="button" class="btn btn-secondary" @click="showDeclineModal=false">Cancel</button>
                  <button type="submit" class="btn btn-primary">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { performanceService } from "@/services/performanceService";
import { employeeService } from "@/services/employeeService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
import { required, sameAs } from "vuelidate/lib/validators";
import StarRating from "vue-star-rating";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker,
    StarRating
  },
  data() {
    return {
      dialog: false,
      year: this.$route.params.id,
      viewstate: 0,
      currentUser: authenticationService.currentUserValue,
      review: null,
      message: "",
      error: "",
      declineReason: "",
      showDeclineModal: false
    };
  },
  mounted() {
    this.getReview();
    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    this.review.status = 1;
        this.review.employeeSignDate = new Date();
        performanceService.updateReview(this.review.id, this.review).then(
          m => {
            this.message = "You have started your review, kindly proceed to fill the form and submit when done";
            this.getReview();
          },
          error => {
            this.error = error;
          }
        );
  },

  methods: {
    setRating(e, p, rd) {
      var rating = parseInt(e);
      console.log(rd);
      console.log(rating);
    },
    setPrev() {
      this.viewstate -= 1;
    },
    setNext() {
      var b = this.review.designationKPIRatings.filter(
        v => v.designationKPI.type == 2
      );
      if (b.length == 0 && this.viewstate == 1) {
        this.viewstate += 2;
      } else {
        this.viewstate += 1;
      }
    },
    getReview() {
      performanceService.getReview(this.year).then(
        model => {
          this.review = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    onEmployeeAccept() {
      this.onEmployeeSubmit(7);
    },
    openDeclineModal() {
      this.declineReason = this.review && this.review.declineReason ? this.review.declineReason : "";
      this.showDeclineModal = true;
    },
    submitDecline() {
      if (!this.declineReason || !this.declineReason.trim()) {
        this.error = "Decline reason is required";
        return;
      }
      this.review.declinedReason = this.declineReason;
      this.showDeclineModal = false;
      this.onEmployeeSubmit(5);
    },
    onEmployeeSubmit(status) {
      if (!this.review) {
        this.error = "Review not loaded yet";
        return;
      }
      if (status === 5 && (!this.declineReason || !this.declineReason.trim())) {
        this.error = "Decline reason is required";
        return;
      }
      if (
        confirm(
          "This changes is irreversible, kindly confirm all your input are correct and ready to submit"
        )
      ) {
        this.review.status = status ? status : 2;
        if (this.review.status === 5) {
          this.review.employeeAcceptance = false;
        }
        if (this.review.status === 7) {
          this.review.employeeAcceptance = true;
        }
        this.review.employeeSignDate = new Date();
        if (status === 5 && this.declineReason) {
          this.review.declineReason = this.declineReason;
        }

        performanceService.updateReview(this.review.id, this.review).then(
          m => {
            this.message = "Review have been updated successful";
            this.getReview();
          },
          error => {
            this.error = error;
          }
        );
      }
    }
  },
  name: "reviews"
};
</script>
<style scoped>
.datatable > thead > tr > th,
.datatable > tbody > tr > td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/review/employeeReviewDetail.vue